/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import { createGlobalStyle } from 'styled-components';
import 'primeicons/primeicons.css';
import { LocalStorage } from '../../utils/localStorage';
import TabsComponent from '../../components/common/component/TabsComponent';
import UsageNote from '../UsageNote';
import TransferCoefficient from '../TransferCoefficient';
import ReceivingEnvironment from '../ReceivingEnvironment';
import { getParamsEnvironment } from '../../utils/helpers/apiHelper';
import {
  ChemicalStationsApi,
  NearestChemicalStationsApi,
  NearestEnvironmentApi,
  ReceivingEnvironmentApi,
  WaterCoursEnvironmentApi,
} from '../../utils/api';
import { formReceivingType } from '../../utils/Interface';
import SeuilParam from '../SeuilParam';
import { Toast } from 'primereact/toast';
import { resetImputLabel } from '../../utils/helpers/module/filtersHelper';
import H2SParam from '../H2SParam/H2SParam';
import { loaderDataComponent } from '../../utils/helper';

type SeuilProps = {
  IsVisible: boolean;
  title: string;
  mode: string;
};

interface TabProps {
  label: string;
  description: string;
  content: React.JSX.Element;
}

const ParamComponent: FC<SeuilProps> = ({ IsVisible, title, mode }) => {
  const [modalVisible, setModalVisible] = useState<any>(IsVisible);
  const [, setParamName] = useState('');
  const [dataList, setDataList] = useState<any>();
  const [nearestHydro, setNearestHydro] = useState<any>();
  const [stations, setStations] = useState<any>();
  const [chemicalStations, setChemicalStations] = useState<any>();
  const [nearestChemicalStations, setNearestChemicalStations] = useState<any>();
  const [waterCours, setWaterCours] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [, setError] = useState(false);
  const [onLabelChange, setOnLabelChange] = useState(false);
  const [, setUpdateLoading] = useState(false);
  const [checkStation] = useState(false);
  const [form, setForm] = useState<formReceivingType>({
    id: waterCours?.id,
    label: waterCours?.name,
    stationLabel: waterCours?.stationLabel,
    chemicalStationLabel: waterCours?.chemicalStationLabel,
    coastline: waterCours?.coastline,
    comment: waterCours?.comment,
  });
  const toastError = useRef<any>(null);
  const toastSucess = useRef<any>(null);
  const [stationError] = useState({
    severity: 'error',
    summary: 'Erreur',
    detail:
      "La station hydrométrique ou la station physico-chimique n'appartient pas au milieu récepteur sélectionné",
    life: 5000,
  });

  const [code, setCode] = useState(window.sessionStorage.getItem('Code'));

  //useEffect
  useEffect(() => {
    const localName = LocalStorage.prName.get();
    if (localName !== null) {
      setParamName(localName.toString());
    }
    setCode(window.sessionStorage.getItem('Code'));
    const promise1 = ReceivingEnvironmentApi.getEnvironment(code);
    const promise2 = WaterCoursEnvironmentApi.getWaterCours(code);
    getParamsEnvironment(
      promise1,
      promise2,
      setDataList,
      setWaterCours,
      setLoading,
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // avoid api calls if no label for station
    if (waterCours?.label !== null) {
      // if no chemical station in water cours go get it
      if (
        (waterCours?.chemicalStationLabel === null ||
          waterCours?.chemicalStationLabel === '') &&
        waterCours?.label !== null
      ) {
        const promise = NearestChemicalStationsApi.getNearest(
          code,
          waterCours?.label,
        );
        getParamsEnvironment(
          promise,
          setNearestChemicalStations,
          setLoading,
          setError,
        );
      }
      // if no hydro station in water cours go get it
      if (
        waterCours?.stationLabel === null ||
        waterCours?.stationLabel === ''
      ) {
        const promise = NearestEnvironmentApi.getNearest(code);
        getParamsEnvironment(promise, setNearestHydro, setLoading, setError);
      }
    }
  }, [waterCours?.label]);

  useEffect(() => {
    if (waterCours?.label !== null && form?.label !== 'littoral') {
      if (form?.label !== undefined) {
        // when you change environment, get stations and physical stations
        setStations(
          dataList?.filter((station) => station.name === form?.label)[0]
            ?.stations,
        );
        // get physical stations
        const waterCoursLabel = form?.label !== 'littoral' && form?.label;
        if (waterCoursLabel !== false) {
          const promise1 = ChemicalStationsApi.getChemicalStations(
            code,
            waterCoursLabel,
          );
          getParamsEnvironment(
            promise1,
            setChemicalStations,
            setUpdateLoading,
            setError,
          );
        } else {
          setChemicalStations([]);
        }
        // for toast
        if (onLabelChange) {
          // only show this message when set receptor option
          if (form.coastline === false) {
            toastError.current?.show({
              severity: 'info',
              summary: 'Info',
              detail:
                'Veuillez sélectionner ainsi les stations hydrométrique et physico-chimique',
              life: 5000,
            });
          }
          setOnLabelChange(false);
          // reset dropdownlists
          setForm({
            ...form,
            stationLabel: '',
            chemicalStationLabel: '',
          });
          resetImputLabel('milieu-filtre-stationLabel');
          resetImputLabel('milieu-filtre-chemicalStationLabel');
        }
      }
    }
  }, [form?.label]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (waterCours && dataList) {
      // prepare form
      const label = waterCours?.label || nearestHydro?.name;
      const stationLabel =
        waterCours?.stationLabel || nearestHydro?.stations[0]?.name;
      const chemicalStationLabel =
        waterCours?.chemicalStationLabel || nearestChemicalStations?.name;
      setForm({
        ...waterCours,
        label: !label ? 'littoral' : label,
        stationLabel: !stationLabel ? 'littoral' : stationLabel,
        chemicalStationLabel:
          chemicalStationLabel !== undefined ? chemicalStationLabel : '',
        coastline:
          (!label || label === 'littoral' || waterCours.coastline === true) &&
          true,
      });
    }
  }, [waterCours, dataList, nearestHydro, nearestChemicalStations]);

  // Function to rundring H2s component
  const desktopH2sContent = () => {
    return (
      <div style={{ overflowY: 'auto' }}>
        <H2SParam
          mainInstallCode={code as string}
        />
      </div>
    );
  };

  const desktopMilieuContent = () => {
    return (
      <div style={{ overflowY: 'auto' }}>
        {loading === false && <TabsComponent tabs={tabs} />}
        {loaderDataComponent(loading, ` width: 28px;
          height: 28px;
          border: 5px solid #FFF;
          border-bottom-color: #243977;
          border-radius: 50%;
          display: inline-block;
          box-sizing: border-box;
          animation: rotation 1s linear infinite;`)}
      </div>
    );
  };

  // reset dropdownlist when you choose littoral for the station
  const setDropdownlists = () => {
    resetImputLabel('milieu-filtre-receptor');
    resetImputLabel('milieu-filtre-stationLabel');
    resetImputLabel('milieu-filtre-chemicalStationLabel');
    setChemicalStations([]);
    setStations([]);
  };

  // Tabs Props Array
  const tabs: TabProps[] = [
    {
      label: 'Milieu récepteur',
      description:
        'Les milieux proposés sont dans un rayon de 25 km de l’installation',
      content:
        <ReceivingEnvironment
          dataList={dataList}
          stations={stations}
          chemicalStations={chemicalStations}
          form={form}
          checkStation={checkStation}
          setWaterCours={setWaterCours}
          setForm={setForm}
          code={code}
          toastError={toastError}
          toastSucess={toastSucess}
          stationError={stationError}
          setOnLabelChange={setOnLabelChange}
          setDropdownlists={setDropdownlists}
        />
    },
    {
      label: "Note d'usage",
      description:
        'La note d’usage est calculée en fonction des réponses de ce questionnaire.Les réponses sont sauvegardées automatiquement',
      content: <UsageNote coastline={waterCours?.coastline} />,
    },
    {
      label: 'Coefficient de transfert',
      description: 'Les réponses sont sauvegardées automatiquement',
      content: <TransferCoefficient />,
    },
  ];

  return (
    <Container className='sds-reset-style'>
      <Styles />
      <Toast id='toast-error' ref={toastError} />
      <Toast id='toast-success' ref={toastSucess} />
      {/* param h2s */}
      {mode === 'h2s' && (
        <ModalFlexible
          className='h2sView'
          title={title}
          toggleModal={() => {
            setModalVisible(!IsVisible);
          }}
          visible={modalVisible}
          desktopContent={desktopH2sContent}
        />
      )}
      {/* param pr rm */}
      {mode === 'prMr' && <SeuilParam IsVisible={true} />}
      {/* param milieu */}
      {mode === 'milieu' && (
          <ModalFlexible
            visible={modalVisible}
            toggleModal={() => {
              setModalVisible(!IsVisible);
            }}
            className='milieuView'
            title={title}
            desktopContent={desktopMilieuContent}
          />
        )
      }
    </Container>
  );
};
const Styles = createGlobalStyle`
.milieuView {
  .modal-flex-desktop-content .modal-flex-desktop-scrollable {
    width: 50vw !important;
  }
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position {
    top: 5%;
    bottom: auto;
    height: auto;
    width: 100%;
    min-width: 55%;
  }
}
.h2sView {
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position {
    top: 5%;
    bottom: auto;
    height: 90%;
    width: auto;
    min-width: 55%;
  }
}
  .modal-flex-desktop-content .modal-flex-desktop-header {
    display: flex !important;
    justify-content: end !important;
    padding: 0px !important;
  }
.pi{
  font-family: 'primeicons';
  color: white;    
}
.modalContainer {
  z-index: 200;
  .modal-flex-desktop-content {
    background-color: #FFFFFF;
  border-radius: 23px 0 0 23px;
  height: 1200px;
  }
}
.usage-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
  svg{
    margin-top: 3px;
    margin-right: 5px;
  }
  span{
  font-size: 20px !important;
  }
}
`;
export default React.memo(ParamComponent);
